import { JsonObject, UiOption } from '@/lib/helpers';
import { IdentProviderModel } from './ident-provider.model';
import { OidcIdentConfig, OidcIdentProviderModel } from './oidc-ident-provider.model';
import { cloneDeep } from 'lodash';
import { MagiclinkIdentProviderModel } from './magiclink-ident-provider.model';
import { SamlIdentConfig, SamlIdentProviderModel } from './saml-ident-provider.model';

export type IdentProviderType = 'OIDC' | 'SAML' | 'magicLink' | 'password';

export type IdentProviderSubtype = 'MANUAL' | 'SAML-XML' | 'SAML-URL';

export type IdentProviderConfig = OidcIdentConfig | SamlIdentConfig;

export const IdentProviderMap: Map<IdentProviderType, IdentProviderModel> = new Map();
IdentProviderMap.set('OIDC', new OidcIdentProviderModel());
IdentProviderMap.set('SAML', new SamlIdentProviderModel());
IdentProviderMap.set('magicLink', new MagiclinkIdentProviderModel());

export const IdentProviderTypeOptions: UiOption[] = Array.from(IdentProviderMap.entries())
  .filter(([, model]) => !model.optDisabled)
  .map(([type, model]) => {
    return {
      label: model.typeLabel,
      value: type as string,
      disabled: !model.canAdd,
    };
  });

export const getTypedIdentProvider = <T extends IdentProviderModel>(
  model: IdentProviderModel
): T => {
  const typedModel = IdentProviderMap.get(model.type);

  if (!typedModel) {
    return model as T;
  }

  const Constructor = typedModel.constructor as new (data?: JsonObject) => typeof typedModel;

  const identityProviderConfig = {
    ...typedModel.identityProviderConfig,
    ...model.identityProviderConfig,
  };

  const data = cloneDeep({ ...model._props, identityProviderConfig });

  return new Constructor(data) as T;
};
